import type { MenuConfig } from '~typings/menu'

import permisosContabilidadPg, { RESOURCE_CONTABILIDAD_PG } from '@/auth/permissions/modules/contabilidadPg'
import * as names from '@routes/contabilidad-pg/nombres/transacciones'

const { transacciones } = permisosContabilidadPg
export default [
    {
        title: 'contabilidad.transacciones.cierre_contable.menu_title',
        route: names.ROUTE_CIERRE_CONTABLE,
        resource: RESOURCE_CONTABILIDAD_PG,
        action: transacciones.cierreContable,
    },
    {
        title: 'contabilidad.transacciones.exportar_diarios.menu_title',
        fontIcon: 'sitemap',
        route: names.ROUTE_EXPORTAR_DIARIO,
        resource: RESOURCE_CONTABILIDAD_PG,
        action: transacciones.exportarDiario,
    },
    {
        title: 'contabilidad.transacciones.importar_diarios.menu_title',
        fontIcon: 'sitemap',
        route: names.ROUTE_IMPORTAR_DIARIO,
        resource: RESOURCE_CONTABILIDAD_PG,
        action: transacciones.importarDiario,
    },
    {
        title: 'contabilidad.transacciones.transaccion_contable.menu_title',
        route: names.ROUTE_TRANSACCIONES_CONTABLES,
        resource: RESOURCE_CONTABILIDAD_PG,
        action: transacciones.transaccionesContables,
    },
] as MenuConfig[]
